<template>
  <span>
    PUCC Form Is Filled
  </span>
</template>
<script>

export default {
  name: 'PuccFormIsFilled',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
